<label>
  <b>
    <ng-container *ngIf="field.translationPath; else plainTitle">
      <span [translate]="field.translationPath"></span>
    </ng-container>
    <ng-template #plainTitle> {{ field?.title }} </ng-template>
    <span style="color: red" *ngIf="field?.isRequired && inputMode"> *</span>
  </b>
</label>
<ng-container *ngIf="inputMode" [formGroup]="inputGroup">
  <nz-radio-group
    [(ngModel)]="field.value"
    [formControlName]="field.name"
    [attr.autocomplete]="autoFill"
    [ngClass]="{ 'has-error': inputIsValid() === false, 'has-success': inputIsValid() === true }"
    (ngModelChange)="handleValueChange($event)"
  >
    <label nz-radio *ngFor="let option of field.options" [nzValue]="option.value">{{ option.label }}</label>
  </nz-radio-group>
</ng-container>
<div class="field-value" *ngIf="!inputMode">
  <span>{{ field?.value ? field?.value : '-' }}</span>
</div>
<p
  *ngIf="this.inputGroup.controls[this.field.name].dirty && this.inputGroup.controls[this.field.name].invalid"
  translate
>
  {{ field.validationMessage }}
</p>
